/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CarEventsFeaturesEnum {
    COLOR = 'color',
    DESCRIPTION = 'description',
    LICENSE_PLATE = 'license_plate',
}